import React from 'react';
import Select, { SelectOption } from './Select';
import { LOST_REASONS, LOST_REASON_OTHER_MAXLEN } from '../constants/consultationStatus';

interface Props {
  lostReason: string;
  lostReasonOther: string;
  onChange: (next: { lostReason: string; lostReasonOther: string }) => void;
  noteError?: string;
}

/**
 * Shown only when status === 'not_interested'. A fixed reason list plus an
 * 80-char free-text note when "Other" is picked. Shared by the create and edit
 * forms. See docs/specs/consultation-status-lifecycle.md.
 */
const ConsultationLostReasonField: React.FC<Props> = ({ lostReason, lostReasonOther, onChange, noteError }) => {
  const selected = LOST_REASONS.find((r) => r.value === lostReason) || null;

  return (
    <>
      <div className="form-group">
        <label htmlFor="lostReason">Lost reason</label>
        <Select<string, SelectOption<string>>
          value={selected}
          onChange={(opt) => onChange({ lostReason: opt ? opt.value : '', lostReasonOther: '' })}
          options={LOST_REASONS}
          placeholder="Select a reason…"
          isClearable
          noOptionsMessage="No reasons"
        />
      </div>

      {lostReason === 'other' && (
        <div className="form-group">
          <label htmlFor="lostReasonOther">Reason note</label>
          <input
            type="text"
            id="lostReasonOther"
            name="lostReasonOther"
            value={lostReasonOther}
            onChange={(e) => onChange({ lostReason, lostReasonOther: e.target.value })}
            maxLength={LOST_REASON_OTHER_MAXLEN}
            placeholder="Briefly, why?"
            className={`form-input ${noteError ? 'error' : ''}`}
          />
          {noteError
            ? <span className="error-text">{noteError}</span>
            : <span style={{ fontSize: '12px', color: '#9ca3af' }}>{lostReasonOther.length}/{LOST_REASON_OTHER_MAXLEN}</span>}
        </div>
      )}
    </>
  );
};

export default ConsultationLostReasonField;
